import React from "react";
import styled from "styled-components";
import { Colors } from "../../config";

const DropdownMultiSelect = ({ closeDropdown, selected = [], onHotelSelect, hotelTypes, name }) => {
  
  const handleSelect = (item) => {
    let updated;

    if (selected.includes(item.id)) {
      // remove from selection
      updated = selected.filter((id) => id !== item.id);
    } else {
      // add to selection
      updated = [...selected, item.id];
    }

    onHotelSelect({
      target: { value: updated, name },
    });
  };

  return (
    <DropdownWrapper>
      <DropdownList>
        {hotelTypes.map((item) => (
          <DropdownItem
            selected={selected.includes(item.id)}
            key={item.id}
            onClick={() => handleSelect(item)}
          >
            {item.name}
          </DropdownItem>
        ))}
      </DropdownList>
    </DropdownWrapper>
  );
};

export default DropdownMultiSelect;

// Styled Components

const DropdownWrapper = styled.div``;

const DropdownList = styled.div`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const DropdownItem = styled.div`
  padding: 16px 12px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  color: ${(props) => (props.selected ? Colors.white : Colors.prussianBlue)};
  background: ${(props) =>
    props.selected ? Colors.prussianBlue : Colors.white};

  &:hover {
    background-color: ${(props) =>
      props.selected ? Colors.prussianBlue : "#f0f0f0"};
    color: ${(props) => (props.selected ? Colors.white : Colors.prussianBlue)};
  }
`;
